<template>
  <div class="container">
    <el-form
      ref="form"
      :model="form"
      :rules="realRules"
      @submit.native.prevent="handleSubmit"
    >
      <el-row
        class="row"
        :gutter="20"
      >
        <el-col
          :span="4"
          class="stepTitle"
        >
          <span class="label">
            {{ $t('targetService.title') }}
            <el-tooltip
              class="item"
              effect="dark"
              :visible-arrow="false"
              placement="top"
              popper-class="targetService-popper"
            >
              <div
                class="urlTip"
                slot="content"
              >
                {{ $t('targetService.tooltip', { projectName: taskData.projectName }) }}
              </div>
              <i
                class="el-icon-question questionIcon"
                tabindex="-1"
              ></i>
            </el-tooltip>
          </span>
        </el-col>
        <el-col
          :span="17"
          :offset="2"
        >
          <el-form-item prop="targetServiceUrl">
            <el-input
              :disabled="status === 'checking'"
              tabindex="2"
              @focus="handleLoginCheck"
              :placeholder="$t('targetService.placeholder')"
              @blur="handleBlur"
              v-model.trim="form.targetServiceUrl"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span class="placeholder"></span>
        </el-col>
        <el-col
          :span="17"
          :offset="2"
        >
          <span class="waningText"></span>
          <span class="info">
            <i18n path="targetService.securityWarning">
              <el-tooltip
                class="item"
                effect="dark"
                :visible-arrow="false"
                placement="top"
                popper-class="targetService-warningTip"
              >
                <div
                  class="urlTip"
                  slot="content"
                >
                  <div class="urlTipText">{{ $t('targetService.securityTerms.waf') }}</div>
                  <div class="urlTipText">{{ $t('targetService.securityTerms.ids') }}</div>
                  <div class="urlTipText">{{ $t('targetService.securityTerms.ips') }}</div>
                  <div class="urlTipText">{{ $t('targetService.securityTerms.edr') }}</div>
                  <div class="urlTipText">{{ $t('targetService.securityTerms.hids') }}</div>
                </div>
                <i
                  class="el-icon-question questionIcon"
                  tabindex="-1"
                ></i>
              </el-tooltip>
            </i18n>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="infoWrapper">
      <url-check
        v-model="status"
        ref="urlCheck"
        :url="form.targetServiceUrl"
        :retry="retry"
        skipScreenShot
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/lib/events';

import UrlCheck from './url-check.vue';

export default {
  name: 'TargetService',
  components: {
    UrlCheck,
  },
  inject: ['taskData'],
  props: {
    payload: Object,
  },
  data() {
    const { url } = this.payload || {};

    return {
      form: {
        targetServiceUrl: url || '',
      },
      rules: {
        targetServiceUrl: [
          { required: true, message: this.$t('targetService.validation.required'), trigger: 'blur' },
          // {
          //   type: 'url',
          //   message: this.$t('targetService.validation.url'),
          //   trigger: ['blur'],
          // },
          {
            validator: (rule, value, callback) => {
              // 判断 value 只能是域名，不能是ip网址形式的 url
              const regex = /^(https?:\/\/)?((?!(?:\d{1,3}\.){3}\d{1,3})[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,})(?::\d+)?(?:\/[^\s]*)?$/;
              if (!regex.test(value) && !this.isAdmin) {
                callback(new Error(this.$t('targetService.placeholder')));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      status: '',
    };
  },
  watch: {
    status(val) {
      if (val === 'checking') {
        this.$emit('next-loading', true);
      } else {
        this.$emit('next-loading', false);
      }
    },
    'form.targetServiceUrl': {
      immediate: true,
      handler(val) {
        this.$emit('next-disabled', !val);
        this.status = '';
      },
    },
  },
  computed: {
    ...mapGetters('user', ['hasAccess', 'isAuthenticated', 'isAdmin']),
    realRules() {
      if (this.hasAccess) {
        return this.rules;
      }

      return [];
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('next');
    },
    handleBlur() {
      const { targetServiceUrl } = this.form;

      // 去掉 url 中的参数
      if (targetServiceUrl.includes('?')) {
        this.form.targetServiceUrl = targetServiceUrl.split('?')[0];
      }
    },
    retry() {
      this.status = 'connecting';

      this.validate().then(this.checkUrl);
    },
    checkUrl() {
      this.$refs['urlCheck'].getWebsiteScreenshot();
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return reject('form error');
          }

          return resolve();
        });
      });
    },
    next() {
      if (!this.checkUrl) {
        return;
      }

      if (this.status === 'connecting') {
        return;
      }

      if (this.status === 'success' || this.status === 'checked') {
        return { stage: 'TargetService', data: { targetServiceUrl: this.form.targetServiceUrl } };
      }

      this.validate().then(this.checkUrl);

      return;
    },
    handleLoginCheck() {
      if (!this.isAuthenticated) {
        EventBus.$emit('signIn');
        return;
      }

      if (!this.hasAccess) {
        EventBus.$emit('noAccess');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media screen and (max-width: 1440px) {
    .info {
      font-size: 14px;
    }
  }

  .waningText {
    display: inline-block;
    margin-right: 10px;
    background: url(~@assets/images/warning.png) no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
  }

  .row {
    line-height: 40px;
  }

  .rowCenter {
    display: flex;
    align-items: center;
  }

  .label {
    font-weight: bold;
    white-space: nowrap;
  }

  .placeholder {
    display: block;
    height: 20px;
  }

  .info {
    color: #909399;
  }

  .progress {
    margin-top: 20px;
    width: 80%;
    margin: 0 auto;
  }

  .infoWrapper {
    margin-top: 40px;
  }

  .textCenter {
    text-align: center;
  }

  .errorContent {
    width: fit-content;
    margin: 0 auto;
  }

  .stageIcon {
    font-size: 20px;
    color: #909399;
  }

  .errorIcon {
    color: #f56c6c;
    font-size: 20px;
  }

  .successIcon {
    color: #67c23a;
    font-size: 20px;
  }

  .diagList {
    line-height: 2em;
  }

  .errorTip {
    color: #ff001f;
    margin-top: 20px;

    &.success {
      color: #909399;
    }
  }

  .ipWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ipLabel {
    margin-right: 20px;
  }

  .ipContent {
    margin-right: 40px;
  }

  .successContent {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .el-icon-success {
      margin-right: 40px;
    }
  }

  .ipText {
    margin-right: 20px;
    font-weight: bold;
  }

  .questionIcon {
    display: inline-block;
  }

  .imageWrapper {
    display: flex;
    justify-content: center;
  }
}
</style>

<style lang="scss">
.urlTip {
  word-break: break-word;

  .urlTipText {
    white-space: nowrap;
  }
}
</style>